import { useEffect, useRef } from 'react';

import { useNotices } from '@/features/notices/useNotices';
import {
  ApiDocumentDownloadResponse,
  ApiDocumentResponseV2,
  ApiTaskDocumentResponseV2,
} from '@/shared/api';
import { useModalsStore } from '@/widgets/modals';
import { mimeTypeToFileInfoFileType } from '@/widgets/modals/containers/FilePreviewModal/FilePreview/helpers';

import { useDocuments } from './useDocuments';

export const useOpenDocument = () => {
  const loadingDocuments = useRef<Record<string, boolean>>({});
  const responseCache = useRef<Record<string, ApiDocumentDownloadResponse>>({});
  const { downloadDocument } = useDocuments();
  const notices = useNotices();
  const modals = useModalsStore();

  useEffect(() => {
    return () => {
      responseCache.current = {};
    };
  }, []);

  return async (item: ApiDocumentResponseV2 | ApiTaskDocumentResponseV2) => {
    if (loadingDocuments.current[item.id]) return;

    const data = responseCache.current[item.id];

    if (!data) {
      loadingDocuments.current[item.id] = true;
      const res = await downloadDocument(item.filePath);
      loadingDocuments.current[item.id] = false;

      if (!res) return;

      responseCache.current[item.id] = res;
    }

    const type = mimeTypeToFileInfoFileType(item.fileType);
    if (!type) {
      notices.error("Can't open file");
      return;
    }

    modals.openModal({
      type: 'FilePreviewModal',
      fileInfo: {
        name: item.title,
        fileType: type,
        size: Number(item.fileSizeBytes),
        url: responseCache.current[item.id].fileContent,
      },
      mode: 'fileInfo',
    });
  };
};
